import React from 'react';

const TypeIcon = ({ className }) => (
    <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={className}
    >
        <g clipPath='url(#clip0_545_84203)'>
            <path
                d='M10.6799 8.00009L14.3332 10.0868C14.4358 10.1449 14.5212 10.2292 14.5806 10.3311C14.6399 10.433 14.6712 10.5488 14.6712 10.6668C14.6712 10.7847 14.6399 10.9005 14.5806 11.0024C14.5212 11.1043 14.4358 11.1886 14.3332 11.2468L8.66658 14.4934C8.46389 14.6104 8.23396 14.6721 7.99991 14.6721C7.76586 14.6721 7.53594 14.6104 7.33325 14.4934L1.66658 11.2468C1.56398 11.1886 1.47864 11.1043 1.41927 11.0024C1.3599 10.9005 1.32861 10.7847 1.32861 10.6668C1.32861 10.5488 1.3599 10.433 1.41927 10.3311C1.47864 10.2292 1.56398 10.1449 1.66658 10.0868L5.31991 8.00009M8.66658 9.16009C8.46389 9.27711 8.23396 9.33872 7.99991 9.33872C7.76586 9.33872 7.53594 9.27711 7.33325 9.16009L1.66658 5.91342C1.56398 5.85528 1.47864 5.77096 1.41927 5.66907C1.3599 5.56717 1.32861 5.45135 1.32861 5.33342C1.32861 5.21549 1.3599 5.09968 1.41927 4.99778C1.47864 4.89589 1.56398 4.81157 1.66658 4.75342L7.33325 1.50676C7.53594 1.38973 7.76586 1.32813 7.99991 1.32812C8.23396 1.32813 8.46389 1.38973 8.66658 1.50676L14.3332 4.75342C14.4358 4.81157 14.5212 4.89589 14.5806 4.99778C14.6399 5.09968 14.6712 5.21549 14.6712 5.33342C14.6712 5.45135 14.6399 5.56717 14.5806 5.66907C14.5212 5.77096 14.4358 5.85528 14.3332 5.91342L8.66658 9.16009Z'
                stroke='#00225F'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
        <defs>
            <clipPath id='clip0_545_84203'>
                <rect width='16' height='16' fill='white' />
            </clipPath>
        </defs>
    </svg>
);

export { TypeIcon };
